/**
 * FGA Manager Library - Public API
 *
 * This file controls what is exported from the @platform-auth/fga-manager library.
 * Only items exported here are accessible to consuming applications.
 *
 * @packageDocumentation
 */

// Models
export * from './lib/models';

// Services
export * from './lib/services';

// Interceptors
export * from './lib/interceptors';

// Components
export { FgaManagerComponent } from './lib/fga-manager.component';

// Web Component Registration
export { FgaManagerModule, registerFgaManagerElement } from './lib/elements';

// Version
export { FGA_MANAGER_VERSION } from './lib/version';
